import React from 'react'
import { useTranslation } from 'react-i18next'
import { MatchPair, AnswerKeySettings } from '../types'
import MatchEditor from '../../OldPortalComponents/MatchEditor/MatchEditor'

interface MatchingQuestionProps {
  matchAnswer: MatchPair[] | null
  answerKeySettings: AnswerKeySettings
  onMatchEditorChange: (value: MatchPair[]) => void
  onHeaderChange: (value: string[]) => void
}

const MatchingQuestion: React.FC<MatchingQuestionProps> = ({
  matchAnswer,
  answerKeySettings,
  onMatchEditorChange,
  onHeaderChange,
}) => {
  const { t } = useTranslation()

  return (
    <>
      <h4 className="page-subheading">{t('Answer Key')}</h4>
      <MatchEditor
        data={matchAnswer}
        onChange={onMatchEditorChange}
        headerValues={answerKeySettings.headers || ['', '']}
        onHeaderChange={onHeaderChange}
      />
    </>
  )
}

export default MatchingQuestion
